const LatLng = require('../../olycommon/geolocation/latlng');

class LocationService {
    constructor(geolocation, $q) {
        this.$q = $q;
        this.geolocation = geolocation;
        this.latlng = {};
    }

    getCurrentLocation() {
        return this.$q((resolve, reject) => {
            this.geolocation.getCurrentPosition((position) => {
                this.latlng = new LatLng(position.coords);
                resolve(this.latlng);
            }, reject);
        });
    }

    isLocationEnabled() {
        return this.getCurrentLocation();
    }
}

module.exports = LocationService;



// WEBPACK FOOTER //
// ./src/olycommon/location/location.service.js